export const SET_AVAILABLE_PRINTERS = "SET_AVAILABLE_PRINTERS"
export const SET_SELECTED_PRINTER = "SET_SELECTED_PRINTER"
